import { Map } from 'immutable';
import { QuizAndItemAnalysis as QuizAndItemAnalysisPresenter } from './presenter';
import { connect } from '../../../../common/react-redux';
import { getExistingQuiz } from '../../../../common/api/quizzes';
import { getItemAnalyses } from '../../../../reporting/api/itemAnalyses';
import { getQuizAnalysis } from '../../../../reporting/api/quizAnalyses';
import { toggleItemAnalysisRowExpanded } from '../../../../common/actions/reporting';
import { getActiveQuiz } from '../../../../common/selectors/quizzes';
export function mapStateToProps(state, props) {
  var activeQuiz = getActiveQuiz(state);
  return {
    openRows: state.getIn(['reporting', 'item_analysis_row_open'], Map()).toJS(),
    quizAnalysisNotFound: state.getIn(['reporting', 'quiz_analysis', props.activeQuizId, 'notFound'], false),
    quiz: activeQuiz,
    quizAnalysis: activeQuiz.getQuizAnalysis(),
    outcomesEndpoint: state.getIn(['outcomes', 'outcomesEndpoint']),
    outcomesToken: state.getIn(['outcomes', 'outcomesToken'])
  };
}
export var QuizAndItemAnalysis = connect(mapStateToProps, {
  getExistingQuiz: getExistingQuiz,
  getItemAnalyses: getItemAnalyses,
  getQuizAnalysis: getQuizAnalysis,
  toggleItemAnalysisRowExpanded: toggleItemAnalysisRowExpanded
})(QuizAndItemAnalysisPresenter);
export default QuizAndItemAnalysis;